import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';

const StyleCheckbox = withStyles((theme) => ({
  root: {
    backgroundColor: 'transparent',
    color: '#000',
    fontFamily: 'Kanit',
    '&$checked': {
      color: '#000',
      fontFamily: 'Kanit',
    }
  }
}))((props) => <Checkbox color="default" {...props} />);

function CustomCheckbox({...props}) {
  return (
    <StyleCheckbox 
    {...props}
    />
  );
}

export default CustomCheckbox;
